require ('./hirePromotionSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
// @ utilities
const { recordProcess, PROC_HIRE_PROMOTIONS, PROC_END  } = require('utilities/tagging');

class HirePromotionSuccess extends React.Component {
    componentDidMount() {
        recordProcess(PROC_HIRE_PROMOTIONS, PROC_END);
    }

    render () {
        const { immProfileFields, immPromotion  } = this.props;
        const exitLink = '/myprofile/global';
        const promotionDetail = immPromotion.get('subTitle');
        const email = PersonalDataHelper.getEmail(immProfileFields);
        const successMessage = formatText('promotions-setPromotionSuccessTitle');
        const successSubMessage = immPromotion.get('title');
        const mainButtonLabel = formatText('promotions-setPromotionSuccessBackButtonLabel').toUpperCase();
        const mainButton = {
            label: mainButtonLabel,
            url: exitLink
        };

        const successMessageEmail = email ? 'setPromotionSuccessEmail': 'setPromotionSuccessUpdateEmail';
        const injectedStrings = email ? [email] : [];

        return (
            <section className="hire-promotion-success">
                <WizardSuccess
                    successMessage={successMessage}
                    successSubMessage={successSubMessage}
                    mainButton={mainButton}
                >
                    <div className="hire-promotion-success__caption">
                        <FormattedText value="promotions-setPromotionSuccessDetailTitle" />
                        <div className="hire-promotion-success__caption-detail">
                            {promotionDetail}
                        </div>
                        <div className="hire-promotion-success__email-section">
                            <OKMessage type="important">
                                <FormattedText value={`promotions-${successMessageEmail}`}
                                    injectedStrings={injectedStrings}
                                />
                            </OKMessage>
                        </div>
                    </div>
                </WizardSuccess>
            </section>
        );
    }
}

HirePromotionSuccess.propTypes = {
    immProfileFields: PropTypes.object.isRequired,
    immPromotion: PropTypes.object.isRequired
};

module.exports = HirePromotionSuccess;